import React from "react";
import UserItem from "./UserItem";
import "./UserList.css";
import Card from "../../shared/components/UIElements/Card/Card";
const UserList = (props) => {
  if (props.item.length === 0) {
    return (
      <div className="center">
        <Card>
          <h2>No Users Found ! </h2>
        </Card>
      </div>
    );
  }
  // console.log("render", props.item);
  return (
    <ul className="users-list ">
      {props.item.map((user) => (
        <UserItem
          key={user.id}
          id={user.id}
          name={user.name}
          image={user.image}
          placeCount={user.places.length}
        />
      ))}
    </ul>
  );
};

export default UserList;
